import { BTN_RESET_CLASS } from '../constants';

export default function TimeNyangActionChip({ label, count, statusLabel, icon, dark, onClick, isActive, disabled = false }) {
  const isLocked = count === '-';
  const hasStatus = !isLocked && Boolean(statusLabel);
  const isDisabled = isLocked || disabled;
  const valueText = count === '-' ? count : statusLabel || count;

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={onClick}
      className={[
        BTN_RESET_CLASS,
        'relative flex h-14 w-14 flex-col items-center justify-center rounded-[10px]',
        dark ? 'bg-gradient-to-b from-[#3B5CD2] to-[#8B68DD]' : 'bg-gradient-to-b from-white to-[#DFD7FF]',
        isDisabled || isActive ? 'cursor-not-allowed opacity-55' : '',
      ].join(' ')}
    >
      <p
        className={[
          "mb-[2px] w-full text-center font-['Pretendard'] text-[10.5px] font-bold leading-none tracking-[-0.5px]",
          hasStatus ? (dark ? 'text-white/60' : 'text-black/45') : dark ? 'text-white' : 'text-black',
        ].join(' ')}
      >
        {label}
      </p>
      <div className={`flex items-center justify-center gap-1 pt-0.5 ${isLocked ? 'opacity-45' : ''}`}>
        {!hasStatus ? <img src={icon} alt="" className={`h-[10px] w-[13px] ${isLocked ? 'grayscale' : ''}`} /> : null}
        <p
          className={[
            "min-w-0 text-center font-['Pretendard'] text-xs font-black leading-none tracking-[-0.5px]",
            isLocked ? 'text-gray03' : hasStatus ? (dark ? 'text-white/60' : 'text-black/45') : dark ? 'text-white' : 'text-black',
          ].join(' ')}
        >
          {valueText}
        </p>
      </div>
    </button>
  );
}
